import ScoringBrainsTable from './ScoringBrainsTable'

export { ScoringBrainsTable }
export default ScoringBrainsTable
